import { callApi } from 'services/api/api'
import { baseURL } from 'services/api/apiConfig'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'

export const getTutorialFlag = async () => {
  try {
    const response = await callApi(`${baseURL}/user/tutorial`, 'GET')
    return response
  } catch (error) {
    console.log(error)
  }
}

export const dismissTutorialFlag = async () => {
  try {
    const response = await callApi(`${baseURL}/user/tutorial`, 'PUT')
    return response
  } catch (error) {
    console.log(error)
  }
}

export async function userLogout() {
  try {
    return await callApi(`${baseURL}/user/logout`, 'POST')
  } catch (error) {
    console.log(error)
    throw error
  }
}

export async function getUserContext({ showToast = false } = {}) {
  try {
    return await callApi(`${baseURL}/user/context`, 'GET')
  } catch (error) {
    if (showToast) {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting user context')
    } else {
      console.log(error)
    }
    throw error
  }
}

export const getBackendVersion = async () => {
  try {
    const response = await callApi(`${baseURL}/version`, 'GET')
    const commitHash = response?.commitHash
    const buildTimestamp = response?.buildTimestamp

    if (commitHash && buildTimestamp) {
      return commitHash.slice(-5) ? `${commitHash.slice(-5)} at ${buildTimestamp}` : ''
    }

    return commitHash ? commitHash.slice(-5) : buildTimestamp
  } catch (error) {
    return ''
  }
}

export async function downloadAsset(assetName, fileName) {
  try {
    const blob = await callApi(`${baseURL}/assets/${assetName}`)
    const file = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = file
    a.download = fileName ?? assetName
    a.click()
    URL.revokeObjectURL(file)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting asset')
    throw error
  }
}
